/**
 * QUESTION-BENCHMARK-MODAL
 * Lets a level 3 supervisor (CS, connected as the client) give one dashboard question a benchmark:
 * look for an existing bank question to attach it to (magnifier) and, only if none fits, create it
 * in the bank. Same modal as the template editor's benchmark card, fed with this single question
 * instead of the template's list — nothing to maintain twice.
 *
 * The same caveat as in the editor applies: linking only enriches bank_questions.texts[], the
 * benchmark shows up after the next "Calculer" (connected as a client there is no /supervisor/*
 * JWT to recompute a single bank question).
 */
import SupervisorUnmatchedQuestionsModal from "./SupervisorUnmatchedQuestionsModal"

interface Props {
  questionId: string
  //French text of the question: the bank is matched on French texts
  text: string
  onClose: () => void
}

export default function QuestionBenchmarkModal(props: Props) {
  return (
    <SupervisorUnmatchedQuestionsModal
      questions={[{ questionId: props.questionId, text: props.text, axisId: null, topicId: "", bankId: null, hasBenchmark: false }]}
      axisList={[]}
      topicList={[]}
      canAssociate
      autoSearch
      onClose={props.onClose}
      onLinked={props.onClose}
    />
  )
}
